export default "__VITE_ASSET__BjhyqCTJ__"